import { ClientInput } from 'admin/inputs/ClientInput';
import { List } from 'react-admin';

import { ReportDatagrid } from './ReportDatagrid';

export const ReportList: React.FC = () => {
  const filters = [<ClientInput label="Klient" source="client.id" />];

  return (
    <List exporter={false} filters={filters} sort={{ field: 'creationTimestamp', order: 'DESC' }}>
      <ReportDatagrid />
    </List>
  );
};
